import { createAction } from 'redux-actions';
import { moduleName } from './constants';

const types = {
    FETCH_CONFIG: {
        FAILURE: `@@${moduleName}/FETCH_CONFIG_FAILURE`,
        REQUEST: `@@${moduleName}/FETCH_CONFIG_REQUEST`,
        SUCCESS: `@@${moduleName}/FETCH_CONFIG_SUCCESS`,
    },
};

const creators = {
    fetchConfig: {
        failure: createAction<{ error: any, requestAction: any }, any, any>(types.FETCH_CONFIG.FAILURE, (requestAction: any, error: any) => ({
            error,
            requestAction,
        })),
        request: createAction<{}>(types.FETCH_CONFIG.REQUEST),
        success: createAction<any, any>(types.FETCH_CONFIG.SUCCESS, (data) => data),
    },
};

export default {
    creators,
    types,
};


// WEBPACK FOOTER //
// ./src/redux/modules/hft/actions.tsx